export const ANNOUNCEMENT_TYPES = [
  { label: 'Todos', value: 'ALL' },
  { label: 'Por Apartamento', value: 'PER_APARTMENT' },
  { label: 'Por Morador', value: 'PER_RESIDENT' }
] as const;

export const INITIAL_ANNOUNCEMENT_VALUES = {
  title: '',
  description: '',
  type: 'ALL' as const,
  models: []
};